<template>
  <v-col style="height: 90px" cols="10">
    <v-text-field clearable filled rounded type="search" class="mt-2" style="cursor:pointer!important;"
      :placeholder="placeholder" v-model="keyword" id="general-search" @keydown.enter="search" dense readonly
      @click="showSearchDialog = true" v-if="$vuetify.breakpoint.mdAndUp">
    </v-text-field>
    <v-btn class="mt-2" icon v-else @click="showSearchDialog = true"><v-icon>mdi-magnify</v-icon></v-btn>

    <v-dialog transition="slide-y-transition" scrollable persistent :fullscreen="$vuetify.breakpoint.mobile" width="50%"
      v-model="showSearchDialog">
      <v-card>
        <v-toolbar height="20" elevation="0">
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="showSearchDialog = false" text color="red" rounded depressed class="mt-2" x-small>Close
              <v-icon x-small color="red">mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title>
          <v-text-field hint="Focus on the search box and press the enter key if you are not sure of the results"
            persistent-hint clearable autofocus filled rounded type="search" :placeholder="placeholder"
            v-model="keyword" id="general-search" autocomplete="off" @input="debouncedSearch" @keydown.enter="search"
            dense :loading="searching" @click="showSearchDialog = true">
          </v-text-field>
        </v-card-title>
        <v-card-text>

          <div v-if="!searching && (!results || keyword === '')" class="text-center" id="general-search-sheet">
            <v-img src="/img/search.svg" max-width="80px" alt="Panda" class="mx-auto" id="general-search-sheet"></v-img>
            <div class="headline my-2" id="general-search-sheet">
              Search for anything!
            </div>
            <div class="text-gray-600" id="general-search-sheet">
              Find all your transactions such as invoices, quotes, customers and suppliers in one place.
            </div>
          </div>
          <div v-if="searching && keyword.length > 0">
            <div class="text-center">
              <span>Getting results for <b>{{ keyword }}</b></span>
              <v-progress-circular indeterminate size="24" color="primary" class="ml-2"></v-progress-circular>
            </div>
          </div>
          <div v-else-if="!searching && !results && keyword.length > 0">
            <!--            <h1>No results</h1>-->
          </div>
          <div v-if="results">
            <v-tabs v-model="currentTab">
              <v-tab v-for="(tab, index) in tabs" :key="index">
                {{ tab.replaceAll("_", " ") }}
              </v-tab>
            </v-tabs>
            <!--            <v-tabs-slider></v-tabs-slider>-->
            <v-tabs-items v-model="currentTab">
              <v-tab-item v-for="(tab, index) in tabs" :key="index" eager>
                <invoices @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'invoices'"
                  :result="results[tab]"></invoices>
                <expenses @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'expenses'"
                  :result="results[tab]"></expenses>
                <bills @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'bills'" :result="results[tab]">
                </bills>
                <products @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'products'"
                  :result="results[tab]"></products>
                <accounts @selected="receiveAccountsEmit" v-if="tab.toLowerCase() == 'accounts'" :result="results[tab]">
                </accounts>
                <quick-sales @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'quick_sales'"
                  :result="results[tab]"></quick-sales>
                <suppliers @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'suppliers'"
                  :result="results[tab]"></suppliers>
                <quotes @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'quotes'"
                  :result="results[tab]">
                </quotes>
                <customers @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'customers'"
                  :result="results[tab]"></customers>
                <sync-expenses @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'syncexpenses'"
                  :result="results[tab]"></sync-expenses>
                <tags @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'tags'" :result="results[tab]">
                </tags>
                <sync-income @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'syncincomes'"
                  :result="results[tab]"></sync-income>
                <deposits @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'deposits'"
                  :result="results[tab]"></deposits>
                <bank-transfers @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'bank_transfers'"
                  :result="results[tab]"></bank-transfers>
                <journals @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'journals'"
                  :result="results[tab]"></journals>
                <sales-tax @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'sale_tax_payments'"
                  :result="results[tab]"></sales-tax>
                <loans @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'loans'" :result="results[tab]">
                </loans>
                <budgets @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'budgets'"
                  :result="results[tab]">
                </budgets>
                <witholding @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'withholding_tax_payments'"
                  :result="results[tab]"></witholding>
                <stock-taking @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'stock_taking'"
                  :result="results[tab]"></stock-taking>
                <income @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'income_tax_payments'"
                  :result="results[tab]"></income>
                <opening-balances @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'opening_balances'"
                  :result="results[tab]"></opening-balances>
                <prepayments @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'prepayments'"
                  :result="results[tab]"></prepayments>
                <bank-reconciliation @selected="showSearchDialog = false"
                  v-if="tab.toLowerCase() == 'bank_reconciliations'" :result="results[tab]"></bank-reconciliation>
                <wallet-transactions @selected="showSearchDialog = false"
                  v-if="tab.toLowerCase() == 'wallet_transactions'" :result="results[tab]"></wallet-transactions>
                <other-incomes @selected="showSearchDialog = false" v-if="tab.toLowerCase() == 'other_incomes'"
                  :result="results[tab]"></other-incomes>
              </v-tab-item>
            </v-tabs-items>

          </div>

        </v-card-text>
      </v-card>
    </v-dialog>

  </v-col>
</template>

<script>
import { debounce } from "lodash";
import Invoices from "./Invoices.vue";
import Expenses from "./Expenses.vue";
import Bills from "./Bills.vue";
import Witholding from "./Witholding.vue";
import Income from "./Income.vue";
import SalesTax from "./SalesTax.vue";
import Suppliers from "./Suppliers.vue";
import QuickSales from "./QuickSales.vue";
import Quotes from "./Quotes.vue";
import Customers from "./Customers.vue";
import Products from "./Products.vue";
import BankTransfers from "./BankTransfers.vue";
import Journals from "./Journals.vue";
import Loans from "./Loans.vue";
import Accounts from "./Accounts.vue";
import Tags from "./Tags.vue";
import SyncExpenses from "./SyncExpenses.vue";
import SyncIncome from "./SyncIncome.vue";
import Deposits from "./Deposits.vue";
import OpeningBalances from "@/components/GeneralSearch/OpeningBalances.vue";
import Prepayments from "@/components/GeneralSearch/Prepayments.vue";
import Budgets from "@/components/GeneralSearch/Budgets.vue";
import StockTaking from "@/components/GeneralSearch/StockTaking.vue";
import BankReconciliation from "@/components/GeneralSearch/BankReconciliation.vue";
import WalletTransactions from "@/components/GeneralSearch/WalletTransactions.vue";
import OtherIncomes from "@/components/GeneralSearch/OtherIncomes.vue";

export default {
  components: {
    OtherIncomes,
    WalletTransactions,
    BankReconciliation,
    StockTaking,
    Budgets,
    Prepayments,
    OpeningBalances,
    Deposits,
    Invoices,
    Expenses,
    Bills,
    Witholding,
    Income,
    SalesTax,
    Suppliers,
    QuickSales,
    Quotes,
    Customers,
    Products,
    BankTransfers,
    Journals,
    Loans,
    Accounts,
    Tags,
    SyncExpenses,
    SyncIncome,
  },
  data() {
    return {
      showSheet: false,
      results: null,
      showSearchDialog: false,
      currentTab: null,
      filterOptions: [
        { text: "Invoices", value: "invoices", prependText: "invoices" },
        { text: "Expenses", value: "expenses", prependText: "expenses" },
        { text: "Bills", value: "bills", prependText: "bills" },
        {
          text: "Withholding Tax Payments",
          value: "withholding_tax_payments",
          prependText: "withholding",
        },
        {
          text: "Income Tax Payments",
          value: "income_tax_payments",
          prependText: "income tax",
        },
        {
          text: "Sale Tax Payments",
          value: "sale_tax_payments",
          prependText: "sales tax",
        },
        { text: "Suppliers", value: "suppliers", prependText: "suppliers" },
        {
          text: "Quick Sales",
          value: "quick_sales",
          prependText: "quick sales",
        },
        { text: "Quotes", value: "quotes", prependText: "quotes" },
        { text: "Customers", value: "customers", prependText: "customers" },
        { text: "Products", value: "products", prependText: "products" },
        { text: "Stock Taking", value: "stock_taking", prependText: "Stock Taking" },
        {
          text: "Bank Transfers",
          value: "bank_transfers",
          prependText: "bank transfers",
        },
        { text: "Journals", value: "journals", prependText: "journals" },
        { text: "Loans", value: "loans", prependText: "loans" },
        { text: "Accounts", value: "accounts", prependText: "accounts" },
        {
          text: "Sync Incomes",
          value: "syncIncomes",
          prependText: "sync incomes",
        },
        { text: "Tags", value: "tags", prependText: "tags" },
        {
          text: "Sync Expenses",
          value: "syncExpenses",
          prependText: "sync expenses",
        },
      ],
      hasModelSelected: false,
      keyword: "",
      model: undefined,
      searching: false,
    };
  },
  methods: {
    search() {
      if (!this.searching) {
        // this.results = null;
        this.searching = true;
        let params = `keyword=${this.keyword || ""}`;
        if (![null, undefined].includes(this.model)) {
          params += `&model=${this.filterOptions[this.model].value}`;
        }
        axios
          .get(`/api/v2/search?${params}`)
          .then((res) => {
            this.results = res.data;
          })
          .catch((error) => {
            this.results = [];
          })
          .finally(() => {
            this.searching = false;
          });
      }
    },

    handleClickOutside(event) {
      const targetId = event.target.id;
      if (!["general-search", "general-search-sheet"].includes(targetId)) {
        this.showSheet = false;
      }
    },

    receiveAccountsEmit(account_name) {
      this.showSearchDialog = false;
    }
  },
  computed: {

    tabs() {

      const tabs = Object.keys(this.results);

      if (!this.results) {
        return [];
      }

      this.currentTab = tabs[0];


      return tabs;
    },
    shouldShowNoResults() {
      return (
        this.results &&
        this.results?.length > 0 &&
        this.results.every((item) => item.items?.length === 0) &&
        !this.searching
      );
    },
    placeholder() {
      return "Search " + this.$store.state.user.user_infor.current_business.name;
    }
  },
  watch: {
    model(val) {
      if (this.results && this.results.length > 0) {
        this.search();
      }
    },
  },
  created() {
    this.debouncedSearch = debounce(this.search, 1000);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped></style>
